export default (context:any, payload:any) => {
    const startId = `${ payload.sourceId }_complaint-start`;
    const result = [startId];
    context.dispatch('complaintDurationCustomValidation', { root: true }).then(() => {
        if (context.rootState[startId].value.length > 0) {
            context.commit(`${ payload.sourceId }/ADD_TRACKED_ERRORS`, result, { root: true });
        } else {
            context.commit(`${ payload.sourceId }/REMOVE_TRACKED_ERRORS`, result, { root: true });
        }
    });
};